<template>
  <CrudList
    title="Usuarios Reportados"
    storeName="Report_users"
    labelAddNew="Agregar"
    slot-scope="{ item }"
    sortable
    canSearch
  >
    <template v-slot:sender_id="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12" v-if="item.sender_id">
          {{ item.sender_id.full_name }}
        </v-col>
      </v-row>
    </template>

    <template v-slot:receiver_id="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12" v-if="item.receiver_id">
          {{ item.receiver_id.full_name }}
        </v-col>
      </v-row>
    </template>
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
